import React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import './styles.css';

interface ILocation {
  rating: number;
  position: { lat: number; lng: number };
  title: string;
}

const locations: ILocation[] = [
  {
    rating: 1,
    position: { lat: 6.9271213371256595, lng: 79.86015371130105 },
    title: 'Colombo',
  },
  {
    rating: 2,
    position: { lat: 6.03352738684548, lng: 80.21663078123844 },
    title: 'Galle',
  },
  {
    rating: 3,
    position: { lat: 7.939864880120826, lng: 81.01932804680287 },
    title: 'Polonnaruwa',
  },
  {
    rating: 4,
    position: { lat: 6.474842001594403, lng: 80.87632972422927 },
    title: 'Udawalawe National Park',
  },
  {
    rating: 5,
    position: { lat: 6.491596167564576, lng: 81.4261562862324 },
    title: 'Yala National Park',
  },
  {
    rating: 6,
    position: { lat: 9.661411099375137, lng: 80.02533651604956 },
    title: 'Jaffna',
  },
  {
    rating: 7,
    position: { lat: 6.809669709377619, lng: 80.80234402423224 },
    title: 'Horton Plains National Park',
  },
  {
    rating: 8,
    position: { lat: 8.353076510420621, lng: 80.50440045135726 },
    title: 'Mihintale',
  },
  {
    rating: 9,
    position: { lat: 7.855201052671792, lng: 80.65054843773734 },
    title: 'Dambulla Royal Cave Temple and Golden Temple',
  },
  {
    rating: 10,
    position: { lat: 6.810537604770572, lng: 80.49938812920195 },
    title: 'Adams Peak',
  },
  {
    rating: 11,
    position: { lat: 8.312043324430181, lng: 80.40605574673009 },
    title: 'Anuradhapura',
  },
  {
    rating: 12,
    position: { lat: 6.866714940044985, lng: 81.04635992638487 },
    title: 'Ella',
  },
  {
    rating: 13,
    position: { lat: 5.948167771985584, lng: 80.47184935566584 },
    title: 'Mirissa',
  },
  {
    rating: 14,
    position: { lat: 6.837878820842489, lng: 81.82544076842218 },
    title: 'Arugam Bay',
  },
  {
    rating: 15,
    position: { lat: 6.017439912409978, lng: 80.24894704622331 },
    title: 'Unawatuna',
  },
  {
    rating: 16,
    position: { lat: 6.924001204917892, lng: 79.84498603957358 },
    title: 'Galle Face Green',
  },
  {
    rating: 17,
    position: { lat: 7.290622349243309, lng: 80.63315530700527 },
    title: 'Kandy',
  },
  {
    rating: 18,
    position: { lat: 6.949655832644634, lng: 80.78694756035637 },
    title: 'Nuwara Eliya',
  },
  {
    rating: 19,
    position: { lat: 7.958247878971035, lng: 80.76234539282123 },
    title: 'Sigiriya',
  },
  {
    rating: 20,
    position: { lat: 6.139465787104191, lng: 80.10564178198413 },
    title: 'Hikkaduwa',
  },
  {
    rating: 21,
    position: { lat: 6.418832873207823, lng: 80.005374181906 },
    title: 'Bentota',
  },
  {
    rating: 22,
    position: { lat: 7.201703371820099, lng: 79.87129496577906 },
    title: 'Negombo',
  },
  {
    rating: 23,
    position: { lat: 8.587111086209076, lng: 81.2157905013454 },
    title: 'Trincomalee',
  },
  {
    rating: 24,
    position: { lat: 8.229435379972804, lng: 79.75963164027465 },
    title: 'Kalpitiya',
  },
  {
    rating: 25,
    position: { lat: 7.931436624986139, lng: 81.55866128967409 },
    title: 'Pasikuda',
  },
];

const Map: React.FC = () => {
  const isMounted = React.useRef<boolean>(false);

  const initMap = async () => {
    const { Map, InfoWindow } = (await google.maps.importLibrary(
      'maps'
    )) as google.maps.MapsLibrary;
    const { AdvancedMarkerElement, PinElement } =
      (await google.maps.importLibrary('marker')) as google.maps.MarkerLibrary;
    const localMap = new Map(document.getElementById('map') as HTMLElement, {
      mapId: '6dba8519cf99f102',
      center: { lat: 7.883493676327779, lng: 80.65469129535724 },
      zoom: 8,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
    });
    const infoWindow = new InfoWindow();
    locations.forEach(({ rating, position, title }) => {
      const pin = new PinElement({
        background: '#fc0303',
        borderColor: '#000',
        glyph: `${rating}`,
        glyphColor: '#fff',
        scale: 1,
      });
      const marker = new AdvancedMarkerElement({
        position,
        map: localMap,
        title,
        content: pin.element,
      });
      marker.addListener('click', () => {
        infoWindow.close();
        infoWindow.setContent(marker.title);
        infoWindow.open(marker.map, marker);
      });
    });
  };

  React.useEffect(() => {
    if (!isMounted.current) {
      initMap();
    }
    isMounted.current = true;
  }, []);

  return (
    <Container
      maxWidth="lg"
      sx={{ marginTop: 5, marginBottom: 10 }}
      className="map_backdrop"
    >
      <Typography
        gutterBottom
        variant="h3"
        sx={{ marginBottom: 5 }}
        className="title"
      >
        Popular Destinations
      </Typography>
      <div id="map"></div>
    </Container>
  );
};

export default Map;
